import { render, staticRenderFns } from "./profit-loss.vue?vue&type=template&id=b69ea0a4"
import script from "./profit-loss.vue?vue&type=script&lang=js"
export * from "./profit-loss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports